import { all } from "redux-saga/effects";
import { watchCreateCheckout } from "./checkoutSaga";
import { watchInitiateAuthCheck } from "./loginSaga";

export const apiBaseUrl = "https://payment-api.bapsanz.org.au";

export function* rootSaga() {
    yield all([watchCreateCheckout(), watchInitiateAuthCheck()]);
}